import {
  NotificationStatus,
  NotificationType,
} from "../model_gen/notification";
import GeneralService from "./GeneralService";

export class NotificationService {
  public static getNotifications(
    statuses: NotificationStatus[],
    notificationTypes: NotificationType[],
    excludeTypes: NotificationType[],
    loadingHandler: any,
    apiKey: string
  ) {
    let url = "/notification/";
    const searchParams = new URLSearchParams();

    if (notificationTypes && notificationTypes.length > 0) {
      notificationTypes.forEach((type) => {
        searchParams.append("notification_type[]", type);
      });
    }
    if (statuses && statuses.length > 0) {
      statuses.forEach((status) => {
        searchParams.append("status[]", status);
      });
    }
    if (excludeTypes && excludeTypes.length > 0) {
      excludeTypes.forEach((type) => {
        searchParams.append("exclude_type[]", type);
      });
    }
    if (
      statuses.length > 0 ||
      notificationTypes.length > 0 ||
      excludeTypes.length > 0
    ) {
      url += `?${searchParams.toString()}`;
    }

    return GeneralService.get(
      url,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static updateNotificationStatus(
    notification: Notification,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      "/notification/status",
      JSON.stringify(notification),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
}
